export interface IMinMaxTime {
    minTime: string;
    maxTime: string;
}

export function formatTimeTwoDigitAs(time: number): string {
    return (time.toString().length === 1 ? '0' : '') + time.toString();
}

export function getMinMaxTimeUpdate(next: IMinMaxTime, current: IMinMaxTime): IMinMaxTime | null {
    if (next.minTime === current.minTime && next.maxTime === current.maxTime) {
        return null;
    }

    return { minTime: next.minTime, maxTime: next.maxTime };
}

export function toMinMaxTime(minHour: number, maxHour: number): IMinMaxTime {
    let min = Number.isFinite(minHour) ? Math.max(Math.floor(minHour), 0) : 0;
    let max = Number.isFinite(maxHour) ? Math.min(Math.ceil(maxHour), 24) : 24;

    if (min >= max) {
        max = Math.min(min + 1, 24);
        min = Math.max(max - 1, 0);
    }

    return {
        minTime: formatTimeTwoDigitAs(min) + ':00:00',
        maxTime: formatTimeTwoDigitAs(max) + ':00:00'
    };
}
